<template>
  <div class="z-pagination">
    <div class="total">
      共{{' ' +total+' '}}条
    </div>
    <div class="select-pagination">

      <a-select v-model="topageSize" @change="changeSize" dropdownClassName="blue-select">
        <!-- <a-icon slot="suffixIcon" type="down-circle" /> -->
        <template slot="suffixIcon">
          <a-icon type="down-circle" />
        </template>
        <a-select-option :value="8">8条/页</a-select-option>
        <a-select-option :value="10">10条/页</a-select-option>
        <!-- <a-select-option :value="15">15条/页</a-select-option> -->
        <a-select-option :value="20">20条/页</a-select-option>
        <!-- <a-select-option :value="30">30条/页</a-select-option> -->
        <a-select-option :value="50">50条/页</a-select-option>
        <a-select-option :value="100">100条/页</a-select-option>
        <!-- <a-select-option :disabled="total<10" :value="10">10条/页</a-select-option>
        <a-select-option :disabled="total<15" :value="15">15条/页</a-select-option>
        <a-select-option :disabled="total<20" :value="20">20条/页</a-select-option>
        <a-select-option :disabled="total<30" :value="30">30条/页</a-select-option>
        <a-select-option :disabled="total<50" :value="50">50条/页</a-select-option>
        <a-select-option :disabled="total<100" :value="100">100条/页</a-select-option> -->
      </a-select>
    </div>
    <span :class="{disable:currentPage <= 1}" class="previous" @click="previous">
      <img src="@/assets/images/icons/circle-left.png" />
    </span>
    <span class="item">{{currentPage}}/{{totalPage}}</span>
    <span :class="{disable:currentPage >= totalPage}" class="next" @click="next">
      <img src="@/assets/images/icons/circle-right.png" />
    </span>
    <input class="input-topage" v-model.number="topageNum" />
    <span class="to-page" @click="toPage">跳转</span>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 15
    }
  },
  computed: {
    totalPage: function () {
      this.topageSize = this.pageSize
      let tmp = Math.ceil(this.total / this.pageSize);
      return tmp > 0 ? tmp : 1;
    }
  },
  data() {
    return {
      topageNum: null,
      topageSize: 8
    };
  },
  // watch: {
  //   currentPage: function(newValue) {
  //     this.$emit("change", newValue, this.pageSize);
  //   }
  // },
  methods: {
    // 上一页
    previous: function () {
      if (this.currentPage > 1) {
        this.$emit("change", this.currentPage - 1, this.pageSize);

        this.$emit("update:currentPage", this.currentPage - 1);
      }
    },
    // 下一页
    next: function () {
      if (this.currentPage < this.totalPage) {
        this.$emit("change", this.currentPage + 1, this.pageSize);

        this.$emit("update:currentPage", this.currentPage + 1);
      }
    },
    // 跳转
    toPage: function () {
      if (this.topageNum) {
        if (/^[1-9]\d*$/.test(this.topageNum)) {
          if (this.topageNum <= 0) {
            this.topageNum = 1;

            this.$emit("change", 1, this.pageSize);

            this.$emit("update:currentPage", 1);
          } else if (this.topageNum > this.totalPage) {
            this.topageNum = this.totalPage;

            this.$emit("change", this.totalPage, this.pageSize);

            this.$emit("update:currentPage", this.totalPage);
          } else {
            this.$emit("change", this.topageNum, this.pageSize);

            this.$emit("update:currentPage", this.topageNum);
          }
        } else {
          this.topageNum = 1;

          this.$emit("change", 1, this.pageSize);

          this.$emit("update:currentPage", 1);
        }
      }
    },
    //改变每页条数
    changeSize: function () {
      console.log()
      if (this.topageSize) {

        this.$emit("change", 1, this.topageSize);

        this.$emit("update:currentPage", 1);
        this.$emit("update:pageSize", this.topageSize);
      }
    }
  }
};
</script>
<style lang="scss">
.z-pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 30px 50px 30px 30px;
  .total {
    color: #33618f;
    font-family: Microsoft YaHei;
    font-size: 14px;
    line-height: 28px;
    margin-right: 20px;
  }
  .select-pagination {
    height: 28px;
    .ant-select {
      width: 100px;
      margin-right: 26px;
      height: 28px;
      font-size: 14px;
      display: flex;
      align-items: center;
      .ant-select-selection {
        height: 28px;
        border-color: #c5d0d7;
        border-radius: 0px;
      }
      .ant-select-selection-selected-value {
        line-height: 28px;
        .ant-select-selection__rendered {
          height: 28px !important;
          line-height: 28px !important;
          .ant-select-selection-selected-value {
            font-size: 20px;
          }
        }
      }
      svg {
        color: #cccccc;
        font-size: 2px !important; /*no*/
      }
    }
    .ant-select .ant-select-selection {
      width: 100px;
      box-shadow: none;
      /*no*/
    }
    .ant-select-open .ant-select-selection {
      border-color: #89b0eb;
      box-shadow: 0px 0px 1px 1px #89b0eb !important;
      /*no*/
    }
  }
  .previous,
  .next {
    display: flex;
    background: #fff;
    border-radius: 50%;
    img {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
  .disable {
    background: rgba(255, 255, 255, 0.5);
    img {
      cursor: not-allowed;
    }
  }
  .previous:not(.disable):hover,
  .next:not(.disable):hover {
    box-shadow: 0 0 4px rgb(78, 80, 90); /*no*/
  }
  .item {
    padding: 0 12px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgb(51, 97, 143);
  }
  .input-topage {
    margin: 0 12px 0 24px;
    width: 74px;
    height: 28px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgb(51, 97, 143);
    background: rgb(255, 255, 255);
    border: 1px solid rgba(197, 208, 215, 1);
    text-align: center;
  }
  .to-page {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgb(51, 97, 143);
    cursor: pointer;
    user-select: none;
  }
}
</style>